export const CONTACT_CONFIG = {
  phoneNumber: "+44 7478067087",
  
  email: "contact@feesttv.com",
  
  whatsappUrl: "https://wa.me/447478067087",
  
  companyName: "feesttv",
  
  websiteUrl: "https://feesttv.com"
};

export const formatPhoneNumber = (phoneNumber) => {
  return phoneNumber.replace(/\s/g, '');
};

export const createWhatsAppUrl = (phoneNumber, message = "") => {
  const cleanNumber = formatPhoneNumber(phoneNumber);
  return `https://wa.me/${cleanNumber}${message ? `?text=${encodeURIComponent(message)}` : ''}`;
};
